import { orderBy } from 'lodash'

import { store } from 'store/reducers'
import { TAGS_TYPES } from 'common'

import { t } from 'translations'

type parseTagsType = {
  label: string
  options: { label: string; color?: string; value: string; icon: string }[]
}[]

export const getParsedTagsForMultiselect = (): parseTagsType => {
  const {
    resources: { tags }
  } = store.getState() as MStore.RootState

  const parsedTags = TAGS_TYPES.map(tagType => {
    return {
      label: t(`administration.tags.${tagType.toUpperCase()}`),
      options: tags
        .map(({ _id, type, name, color, icon }) => {
          if (type === tagType) return { label: name, color, value: _id, icon }
        })
        .filter(Boolean)
    }
  })

  return orderBy(parsedTags, ['label'])
}
